// extracted by mini-css-extract-plugin
export var active = "_ff-7";
export var blink = "_ff-8";
export var dropDownSelector = "_ff-4";
export var dropDownWrapper = "_ff-3";
export var fakeCursor = "_ff-6";
export var fontSizeButton = "_ff-9";
export var formQuillEditor = "_ff-0";
export var pressed = "_ff-a";
export var qlBlank = "_ff-1";
export var textFormattingToolbar = "_ff-2";
export var textToolbarOption = "_ff-5";